import React from "react";
import { Chip, ChipProps } from "@mui/material";

type ChipColorVariant =
  | "default"
  | "success"
  | "error"
  | "warning"
  | "info";

interface AppChipProps extends Omit<ChipProps, "color"> {
  label: string;
  variantType?: ChipColorVariant;
}

const COLOR_MAP: Record<ChipColorVariant, ChipProps["color"]> = {
  default: "default",
  success: "success",
  error: "error",
  warning: "warning",
  info: "info",
};

const AppChip: React.FC<AppChipProps> = ({
  label,
  variantType = "default",
  ...rest
}) => {
  return (
    <Chip
      label={label}
      color={COLOR_MAP[variantType]}
      {...rest}
    />
  );
};

export default AppChip;
